import React from "react";
import { Card, Flex, Image } from "antd";
import Paragraph from "antd/es/typography/Paragraph";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { memberType } from "../../../../types/member";
import rightArrow from "../../../../assets/icons/arrow-right.svg";

type MemberAccordionProps = {
  hidden?: boolean;
  data: memberType;
  preview?: boolean;
};

const MemberAccordion: React.FC<MemberAccordionProps> = ({
  hidden = false,
  data,
  preview = false,
}: MemberAccordionProps) => {
  const { t } = useTranslation();

  if (hidden) return null;

  return (
    <Card
      styles={{
        body: {
          padding: 0,
        },
      }}
      className="rounded-[12px]"
      bordered={false}
    >
      <Flex vertical className="w-full rounded-[12px]">
        {data.is_enabled_member_benefits && data.member_benefits_url ? (
          <Link
            className="p-4 border-b border-lineColor last:border-none"
            to={data.member_benefits_url}
            target={preview ? "_blank" : "_self"}
          >
            <Flex justify="space-between">
              <Paragraph className="body-medium text-o-body">
                {t("Member Benefits")}
              </Paragraph>
              <Image src={rightArrow} preview={false} />
            </Flex>
          </Link>
        ) : null}
        {data.is_enabled_faq && data.faq_url ? (
          <Link
            className="p-4 border-b border-lineColor last:border-none"
            to={data.faq_url}
            target={preview ? "_blank" : "_self"}
          >
            <Flex justify="space-between">
              <Paragraph className="body-medium text-o-body">
                {t("Frequently Asked Questions")}
              </Paragraph>
              <Image src={rightArrow} preview={false} />
            </Flex>
          </Link>
        ) : null}
      </Flex>
    </Card>
  );
};
export default MemberAccordion;
